function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  id: "iconfinder_icon-arrow-down-b_211614",
  d: "M96.076,160.644l.047.055,3.544,4.078a.659.659,0,0,0,.5.224.668.668,0,0,0,.5-.224l3.541-4.07.06-.068a.4.4,0,0,0,.07-.227.422.422,0,0,0-.433-.412H96.433a.422.422,0,0,0-.433.412A.4.4,0,0,0,96.076,160.644Z",
  transform: "translate(-96 -160)",
  fill: "#09b0ee"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 8.338,
    height: 5,
    viewBox: "0 0 8.338 5"
  }, props), _ref);
};

export default __webpack_public_path__ + "storage/admin_static/media/arrow-down-solid.2f2b7345.svg";
export { SvgComponent as ReactComponent };